import * as Yup from 'yup';

const requiredText = () => Yup.string().trim().required('Required');

export const expatValidationSchema = () =>
  Yup.object({
    expatDetails: Yup.object({
      medicalClass: requiredText(),
      emergency: requiredText(),
      continuity: Yup.string().trim().notRequired(),
      continuityNumber: Yup.string().trim().notRequired(),
      exclusion: Yup.string().trim().notRequired(),
      remarks: Yup.string().trim().notRequired()
    })
  });
